import React,{ useMemo } from 'react';
import { createTheme } from "@mui/material/styles";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { themeSettings } from "theme";
import { useSelector } from "react-redux";
import BaseRoute from './routes';
import { AuthProvider } from './context/auth/AuthContext.js';
import "./style.css";

function App() {
  const mode = useSelector((state) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  return (
    <BrowserRouter>
    <ThemeProvider theme={theme}>
    <CssBaseline />
      {/* <Router> */}
        {/* <UserProvider> */}
          <AuthProvider>
            <BaseRoute />
          </AuthProvider>
        {/* </UserProvider> */}
      {/* </Router> */}
    </ThemeProvider>
    </BrowserRouter>

  );
}

export default App;
